package uz.ferro.shop.pages.admin.productgroup

import js.core.jso
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.icons.material.Add
import mui.icons.material.ListAlt
import mui.material.Box
import mui.material.Button
import mui.material.ButtonVariant
import mui.material.CircularProgress
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogTitle
import mui.material.Fab
import mui.material.FabColor
import mui.material.InputLabel
import mui.material.Paper
import mui.material.Size
import mui.material.Table
import mui.material.TableBody
import mui.material.TableCell
import mui.material.TableCellAlign
import mui.material.TableHead
import mui.material.TableRow
import mui.material.TextField
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import react.create
import react.router.dom.useSearchParams
import react.router.useParams
import react.useContext
import react.useEffectOnce
import react.useState
import uz.ferro.shop.Colors
import uz.ferro.shop.NavigationContext
import uz.ferro.shop.PARAM_HISTORY
import uz.ferro.shop.VALUE_NO_BACK
import uz.ferro.shop.api.saveProductGroup
import uz.ferro.shop.manager.ProductGroupManager
import uz.ferro.shop.manager.ProductManager
import uz.ferro.shop.model.Product
import uz.ferro.shop.model.ProductGroup
import uz.ferro.shop.model.ProductGroupProduct
import uz.ferro.shop.navigator.NavigationPage
import uz.ferro.shop.pages.admin.dict.DictEditor
import uz.ferro.shop.pages.admin.dict.DictItemEditor
import uz.ferro.shop.ui.AppText
import uz.ferro.shop.ui.HorizontalLayout
import uz.ferro.shop.ui.VerticalLayout
import uz.ferro.shop.ui.table.CellItem
import uz.ferro.shop.ui.table.HeaderItem
import uz.ferro.shop.ui.table.RowItem
import uz.ferro.shop.ui.table.TableView
import uz.ferro.shop.util.localized
import uz.ferro.shop.util.orZero
import web.console.console
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent
import web.cssom.JustifyItems
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.pct
import web.cssom.px
import kotlin.math.min

val AdminEditProductGroup = FC<Props> {
    val pathParam = useParams()["productGroupId"] ?: return@FC
    val historyParam = useSearchParams().component1()[PARAM_HISTORY]

    val navigator = useContext(NavigationContext)
    var productGroup by useState(ProductGroup())
    val productGroupId = pathParam.toIntOrNull()
    var showGroupProductView by useState(false)
    var selectedGroupProduct by useState<ProductGroupProduct?>(null)
    var showImportDialog by useState(false)
    var importTextArea by useState("")
    var importError by useState("")
    var importedProducts by useState(listOf<Product>())
    var importProgress by useState(false)
    var saveImportProgress by useState(false)

    var groupProducts by useState<List<ProductGroupProduct>>(emptyList())

    fun refreshProducts() {
        productGroupId ?: return
        MainScope().launch {
            groupProducts = ProductGroupManager.getProductGroupProducts((productGroupId))
        }
    }

    fun goBack() {
        if (historyParam == VALUE_NO_BACK) {
            navigator.openPage(NavigationPage.ADMIN_PRODUCT_GROUPS)
        } else {
            navigator.goBack()
        }
    }

    useEffectOnce {
        if (productGroupId != null) {
            MainScope().launch {
                productGroup = ProductGroupManager.getProductGroup(productGroupId)
            }
            refreshProducts()
        }
    }

    AdminEditProductGroupProductView {
        isOpen = showGroupProductView
        onClose = {
            selectedGroupProduct = null
            showGroupProductView = false
        }
        onItemSaved = {
            refreshProducts()
        }
        onItemDeleted = {
            refreshProducts()
        }
        productGroupProduct = selectedGroupProduct
        existingProductsIdList = groupProducts.mapNotNull { it.product?.id }
    }

    Box {
        sx {
            padding = 16.px
        }

        InputLabel {
            +"Maxsulot guruhi"
        }

        VerticalLayout {
            space = 16.px
            sx {
               maxWidth = 400.px
            }

            DictEditor {
                title = "Nomi"
                item = productGroup.name
                onChange = {
                    productGroup = productGroup.copy(name = it)
                }
            }

            Button {
                sx {
                    marginLeft = 16.px
                }
                variant = ButtonVariant.contained
                size = Size.small
                onClick = {
                    if (productGroup.name?.textUzLat.orEmpty().isNotBlank()) {
                        saveProductGroup(productGroup)
                            .then {
                                goBack()
                            }
                    }
                }

                +"Saqlash"
            }
        }

        if (productGroupId != null) {
            HorizontalLayout {
                sx {
                    marginTop = 64.px
                    alignItems = AlignItems.center
                }

                InputLabel {
                    +"Maxsulotlar"
                }

                Fab {
                    sx {
                        marginLeft = 200.px
                    }
                    size = Size.small
                    color = FabColor.primary
                    Add()
                    onClick = {
                        selectedGroupProduct = ProductGroupProduct(
                            productGroup = productGroup,
                            sort = groupProducts.maxOfOrNull { it.sort.orZero() }.orZero() + 1
                        )
                        showGroupProductView = true
                    }
                }

                Button {
                    variant = ButtonVariant.contained
                    startIcon = ListAlt.create()
                    sx {
                        marginLeft = 100.px
                    }
                    onClick = {
                        showImportDialog = true
                    }
                    +"Import"
                }
            }

            Paper {
                sx {
                    width = 100.pct
                    height = 800.px
                    marginTop = 16.px
                    overflow = Overflow.scroll
                    position = Position.relative
                }

                Table {
                    sx {
                        position = Position.absolute
                        top = 0.px
                        right = 0.px
                        bottom = 0.px
                        left = 0.px
                    }

                    stickyHeader = true
                    TableHead {
                        TableRow {
                            TableCell {
                                sx {
                                    width = 120.px
                                }
                                +"Kod"
                            }
                            TableCell {
                                align = TableCellAlign.left
                                +"Nomi"
                            }
                        }
                    }
                    TableBody {
                        groupProducts.forEach { groupProduct ->
                            TableRow {
                                hover = true
                                key = groupProduct.id.toString()

                                onClick = {
                                    selectedGroupProduct = groupProduct.copy(
                                        productGroup = productGroup
                                    )
                                    showGroupProductView = true
                                }

                                TableCell {
                                    +groupProduct.product?.externalId.orEmpty()
                                }

                                TableCell {
                                    +groupProduct.product?.name.localized()
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    fun closeImportDialog() {
        importedProducts = emptyList()
        showImportDialog = false
    }

    fun textToTable(text: String?): List<List<String>> {
        var lines = text.orEmpty().split("\n").filter {
            it.isNotBlank()
        }

        return lines.map { line ->
            line.split("\t")
        }
    }

    fun appendItems(table: List<List<String>>, mappingInfo: MappingInfo) {
        MainScope().launch {
            importProgress = true

            try {
                val allProducts = ProductManager.getAllProducts()
                val idMap = allProducts.associateBy { it.id.orZero() }
                val codeMap = allProducts.associateBy { it.externalId?.trim().orEmpty() }
                importTextArea = ""
                val start = mappingInfo.dataLineStart
                val colMapping = mappingInfo.columnMapping
                val productList = mutableListOf<Product>()
                for (i in start..table.lastIndex) {
                    val row = table[i]

                    val idIndex = colMapping["id"]
                    val codeIndex = colMapping["code"]

                    console.log("Col mapping: $colMapping")
                    console.log("Row: $row")
                    console.log("Code Index: $codeIndex")

                    val id: Long? = idIndex?.let { row[it] }?.trim()?.toLongOrNull()
                    val code: Long? = codeIndex?.let { row[it] }?.trim()?.toLongOrNull()
                    console.log("Code: $code")
                    var product: Product? = null
                    if (id != null) {
                        product = idMap[id]
                        if (product != null && code != null && code.toString() != product.externalId) {
                            // Wrong
                        }
                    }


                    if (code != null) {
                        if (product != null) {
                            // check code.toString() != product.externalId
                        } else {
                            product = codeMap[code.toString()]
                        }
                    }

                    if (product != null) {
                        productList.add(product)
                    }
                }
                importedProducts = productList
            } catch (e: Exception) {
                console.error(e)
            }

            importProgress = false
        }
    }

    fun saveImportedProducts() {
        MainScope().launch {
            saveImportProgress = true
            try {
                var sortStart = groupProducts.maxOfOrNull { it.sort.orZero() }.orZero() + 1

                val group = ProductGroup(
                    id = productGroup.id,
                    products = importedProducts.map { p->
                        ProductGroupProduct(
                            product = p,
                            sort = sortStart++
                        )
                    }
                )

                ProductGroupManager.saveProductGroupProducts(group)
                importedProducts = emptyList()
                showImportDialog = false
                refreshProducts()
            } catch (e: Exception) {
                console.error(e)
            }
            saveImportProgress = false
        }
    }

    fun onImportChange(text: String?) {
        if (text != null && text.isBlank()) {
            return
        }

        var table = textToTable(text)

        var mappingInfo = validateTable(table)

        if (mappingInfo.isValid) {
            appendItems(table, mappingInfo)
            importError = ""
        } else {
            importError = mappingInfo.errorMessage
            importProgress = false
        }
        importTextArea = ""
    }

    Dialog {
        fullWidth = true
        open = showImportDialog
        onClose = { _, _ ->
            closeImportDialog()
        }
        DialogTitle {
            +"Jadvaldan import qilish"
        }
        DialogContent {
            Box {
                sx {
                    display = Display.flex
                    flexDirection = FlexDirection.column
                    alignItems = AlignItems.stretch
                }

                TextField {
                    sx {
                        marginTop = 16.px
                    }
                    multiline = true
                    maxRows = 3
                    value = importTextArea
                    label = ReactNode("Jadval")
                    placeholder = "Ctrl + V"
                    InputLabelProps = jso {
                        shrink = true
                    }

                    onPaste = { event ->
                        val text = event.clipboardData.getData("text/plain")
                        importTextArea = text
                        onImportChange(text)
                    }
                }

                if (importError.isNotBlank()) {
                    AppText {
                        color = Colors.errorText
                        text = importError
                    }
                }

                if (importProgress) {
                    HorizontalLayout {
                        sx {
                            width = 100.pct
                            marginTop = 16.px
                            justifyContent = JustifyContent.center
                        }
                        CircularProgress()
                    }
                }

                Paper {
                    sx {
                        width = 100.pct
                        height = 400.px
                        marginTop = 16.px
                        overflow = Overflow.scroll
                        position = Position.relative
                    }

                    TableView {
                        headers = listOf(
                            HeaderItem(title = "ID", width = 120.px),
                            HeaderItem("Kod", width = 120.px),
                            HeaderItem("Nomi")
                        )
                        items = importedProducts.map { d ->
                            RowItem(
                                key = d.id.toString(),
                                cells = listOf(
                                    CellItem(d.id.toString()),
                                    CellItem(d.externalId),
                                    CellItem(d.name.localized())
                                )
                            )
                        }
                    }
                }
            }
        }

        DialogActions {
            Button {
                onClick = { closeImportDialog() }
                +"Bekor"
            }
            Button {
                onClick = {
                    saveImportedProducts()
                }
                +"Saqlash"
            }
        }
    }
}

private data class ColumnInfo(
    var isValid: Boolean = true,
    var isPartiallyValid: Boolean = false,
    var columnMapping: MutableMap<String, Int> = mutableMapOf(),
    var errorMessage: String = ""
)

private fun isValidColumn(cell: String): Boolean {
    return cell.isNotBlank()
}

fun validateHeaders(table: List<List<String>>): MappingInfo {
    val mappingInfo = MappingInfo()

    if (table.isEmpty()) {
        return MappingInfo(
            isValid = false,
            errorMessage = "Jadval topilmadi"
        )
    }

    var columnInfo: ColumnInfo = ColumnInfo()
    val untilRow = min(1, table.size - 1)

    for (i in 0..untilRow) {
        columnInfo = readColumnMapping(table[i])
        if (!columnInfo.isValid && columnInfo.isPartiallyValid) {
            mappingInfo.isValid = false
            mappingInfo.errorMessage = columnInfo.errorMessage
            return mappingInfo
        }

        if (columnInfo.isValid) {
            mappingInfo.isValid = true
            mappingInfo.columnMapping = columnInfo.columnMapping
            mappingInfo.dataLineStart = i + 1
            break
        } else if (i === untilRow) {
            mappingInfo.isValid = false
            mappingInfo.errorMessage = columnInfo.errorMessage
            return mappingInfo
        }
    }

    if (mappingInfo.dataLineStart >= table.size) {
        mappingInfo.isValid = false
        mappingInfo.errorMessage = "Ma'lumotlar topilmadi"
        return mappingInfo
    }

    return mappingInfo
}

fun validateItems(table: List<List<String>>, mappingInfo: MappingInfo): MappingInfo {
    return mappingInfo
}

fun validateTable(table: List<List<String>>): MappingInfo {
    var mappingInfo = validateHeaders(table)
    if (mappingInfo.isValid) {
        mappingInfo = validateItems(table, mappingInfo)
    }
    return mappingInfo
}

private fun readColumnMapping(tableRow: List<String>): ColumnInfo {
    val columnInfo = ColumnInfo()
    val mapping = mutableMapOf<String, Int>()

    tableRow.forEachIndexed { i, cell ->
        if (mapping.contains(cell)) {
            return ColumnInfo(
                isValid = false,
                isPartiallyValid = false,
                errorMessage = "Dublikat ustunlar mavjud: " + cell
            )
        }

        if (isValidColumn(cell)) {
            mapping[cell.trim()] = i
        }
    }

    if (mapping.containsKey("id").not() && mapping.containsKey("code").not()) {
        columnInfo.isValid = false
        columnInfo.errorMessage = "Ustunlar topilmadi"
    }

    columnInfo.columnMapping = mapping
    return columnInfo
}

data class MappingInfo(
    var isValid: Boolean = false,
    var columnMapping: Map<String, Int> = mapOf(),
    var dataLineStart: Int = 0,
    var errorMessage: String = ""
)
